export default {
	nav: {
		features: "Fonctionnalités",
		screens: "Écrans",
		plans: "Forfaits",
		faq: "Questions",
		contact: "Contact",
		login: "Se connecter",
		tryFree: "Essai gratuit",
		lightMode: "Mode clair",
		darkMode: "Mode sombre",
	},
	hero: {
		eyebrow: "Gestion pour les temples d'Umbanda",
		titleLine1: "Prenez soin de l'axé.",
		titleLine2: "ORI prend soin de la gestion.",
		lead: "Consultants, chaîne médiumnique, rituels, tickets, finances et communication — tout au même endroit, dans le respect des traditions et avec la simplicité que votre temple mérite.",
		ctaPrimary: "Démarrer l'essai gratuit",
		ctaSecondary: "Découvrir le système de l'intérieur",
		trust: "30 jours gratuits · aucune carte demandée pour commencer",
		memberQuestion: "Vous avez reçu une invitation de votre temple ?",
		memberLink: "Se connecter en tant que membre",
		shotAlt: "Tableau de bord ORI",
	},
	features: {
		eyebrow: "Fonctionnalités",
		title: "Tout ce dont votre temple a besoin",
		subtitle: "Un système pensé pour le quotidien du temple — de l'inscription du consultant à l'appel des tickets sur la télévision de la salle.",
		more: "Et aussi : tableau de bord et rapports · photos sur les profils · retours et suivi · disponible en 4 langues.",
		note: "Les paiements et les alertes par WhatsApp sont des options supplémentaires facultatives. Les frais de chaque transaction sur Mercado Pago sont prélevés par la plateforme elle-même, et non par ORI.",
		people: {
			title: "Personnes et chaîne médiumnique",
			text: "Consultants, médiums et membres avec un dossier complet, des photos et un historique de présence.",
		},
		journey: {
			title: "Parcours du médium",
			text: "Suivez l'évolution médiumnique : guides spirituels, orixás et étapes du développement.",
		},
		rituals: {
			title: "Rituels et giras",
			text: "Agenda des rituels, types de rituel et contrôle de présence de la chaîne médiumnique.",
		},
		agenda: {
			title: "Agenda public et réservations",
			text: "Publiez vos rituels via un lien unique et recevez des réservations de présence des consultants — avec approbation et contrôle des places.",
		},
		tickets: {
			title: "Tickets et accueil",
			text: "Distribuez les tickets par guide spirituel et par médium, et imprimez-les sur une imprimante thermique pour moins d'un centime.",
		},
		tv: {
			title: "ORI TV — appel à la TV",
			text: "L'appel des tickets sur la télévision de la salle, en temps réel et avec signal sonore.",
		},
		financial: {
			title: "Finances",
			text: "Fonds, contributions, cotisations et rapports : les comptes du temple sous contrôle.",
		},
		payments: {
			title: "Paiements par PIX",
			text: "Encaissez cotisations et contributions par PIX ou par carte, avec rapprochement automatique et prélèvement récurrent.",
		},
		whatsapp: {
			title: "Notifications sur WhatsApp",
			text: "Facturations, confirmations et rappels aussi sur WhatsApp, avec le consentement de chaque personne.",
		},
		assistant: {
			title: "Assistant avec IA",
			text: "Un assistant intégré au système qui répond aux questions et aide à configurer le temple étape par étape.",
		},
	},
	screens: {
		eyebrow: "De l'intérieur",
		title: "Les écrans que vous utiliserez au quotidien",
		subtitle: "Sans détour : voici à quoi ORI ressemble vraiment.",
		prev: "Précédent",
		next: "Suivant",
		dashboard: {
			title: "Tableau de bord général",
			desc: "Le temple en un coup d'œil : indicateurs, anniversaires, prochains rituels et graphiques.",
		},
		consulentes: {
			title: "Consultants",
			desc: "Recherche, filtres et historique des accueils de chaque consultant.",
		},
		corrente: {
			title: "Chaîne médiumnique",
			desc: "Médiums avec parcours spirituel, orixás et fonctions au sein du temple.",
		},
		rituais: {
			title: "Rituels",
			desc: "Détails du rituel : statut, type, tickets et statistiques.",
		},
		agenda: {
			title: "Agenda public",
			desc: "Un lien où le consultant voit les prochains rituels et réserve sa place — sans connexion.",
		},
		financeiro: {
			title: "Finances",
			desc: "Fonds, objectifs, flux de trésorerie et graphiques sur un seul tableau de bord.",
		},
		pagamentos: {
			title: "Paiements par PIX",
			desc: "Encaissement via Mercado Pago avec rapprochement automatique et prélèvement récurrent.",
		},
		assistente: {
			title: "Assistant ORI",
			desc: "L'IA qui répond aux questions et aide à configurer le temple étape par étape.",
		},
		atendimento: {
			title: "Distribution des tickets",
			desc: "Tickets organisés par guide spirituel et par médium responsable.",
		},
		oritv: {
			title: "ORI TV",
			desc: "Appel des tickets sur la télévision de la salle — le consultant suit son tour.",
		},
		ticket: {
			title: "Ticket imprimé",
			desc: "Code, guide spirituel, médium et horaire imprimés pour moins d'un centime.",
		},
	},
	testimonials: {
		eyebrow: "Qui l'utilise",
		title: "Des temples qui respirent plus légèrement",
		more: "lire plus…",
		less: "afficher moins",
		prev: "Précédent",
		next: "Suivant",
		jean: {
			p1: "Avant d'utiliser ORI, une grande partie de notre temps était consommée par des processus administratifs manuels, comme la gestion des rituels, des accueils, le contrôle financier et bien d'autres tâches du quotidien du temple.",
			p2: "Avec ORI, toute cette gestion est devenue bien plus simple, organisée et efficace. Aujourd'hui, nous parvenons à tout administrer avec beaucoup plus d'agilité, de sécurité et de praticité.",
			p3: "Le plus grand bénéfice, c'est que nous avons cessé de perdre du temps avec la bureaucratie et que nous pouvons consacrer notre énergie à ce qui compte vraiment : la charité, l'accueil et l'accompagnement spirituel des personnes.",
			p4: "Je félicite toute l'équipe pour cet excellent travail. Je recommande ORI à tous les temples qui souhaitent moderniser leur gestion sans perdre le fondement et l'essence de la religion.",
		},
		priscilla: {
			p1: "ORI est arrivé comme un excellent outil pour notre temple en matière de suivi des fréquentants et de leur historique.",
			p2: "Notre temple a pour règle de distribuer les accueils en les orientant vers des entités précises, et ORI m'aide avec l'historique, et même sur la question des demandes des entités pour que le consultant revienne.",
			p3: "En plus de cela, il y a le dossier de tous les médiums du temple, les alertes pour les anniversaires, les alertes financières pour le paiement des cotisations et le contrôle de caisse, où nous parvenons, avec un seul outil, à avoir une vision de toute notre organisation.",
			p4: "Pour moi, ORI est venu faciliter et organiser nos données. En tant qu'organisation religieuse, nous n'avons personne dédié uniquement à cela ; nos administrateurs alimentent donc le système, ce qui me facilite la tâche lorsque j'ai besoin de recueillir des données précises au même endroit.",
			p5: "Je le recommande vivement aux chefs spirituels qui, comme moi, ont une vie professionnelle bien remplie, mais ne renoncent pas à garder notre maison spirituelle toujours en ordre.",
		},
	},
	plans: {
		eyebrow: "Forfaits",
		title: "Un forfait à la mesure de votre temple",
		subtitle: "Une base ORI, plus les options que vous voulez. Les 30 jours gratuits s'appliquent au forfait de base — sans engagement et sans carte.",
		fallback: "Nous n'avons pas pu charger les forfaits pour le moment.",
		fallbackCta: "Essayer 30 jours gratuits",
	},
	faq: {
		eyebrow: "Questions",
		title: "Questions fréquentes",
		trial: {
			q: "Puis-je essayer ORI ?",
			a: "Oui. C'est 30 jours gratuits sur le forfait de base, sans carte de crédit. Les options — paiements via Mercado Pago et alertes par WhatsApp — ne sont pas incluses dans l'essai.",
		},
		security: {
			q: "Mes données sont-elles en sécurité ?",
			a: "Absolument. Nous utilisons le chiffrement, l'isolement par temple et des sauvegardes automatiques. Aucun temple n'accède aux données d'un autre.",
		},
		mobile: {
			q: "Est-ce que ça fonctionne sur mobile et sur tablette ?",
			a: "Sur tablette, le système fonctionne parfaitement. La version pour mobile est en cours d'évolution.",
		},
		tv: {
			q: "Puis-je appeler les tickets à la TV ?",
			a: "Oui. ORI dispose d'une application pour Google TV ou Fire TV qui appelle les tickets en temps réel, en plus d'afficher des messages et des vidéos personnalisés à l'intention des consultants.",
		},
		tickets: {
			q: "Puis-je utiliser mes tickets physiques ?",
			a: "Vous pouvez utiliser vos tickets physiques ou les imprimer sur une imprimante thermique pour moins d'un centime par ticket — avec code, guide spirituel, médium et horaire, et même des messages personnalisés.",
		},
		multiTemple: {
			q: "Puis-je l'utiliser dans plus d'un temple ?",
			a: "Oui. Un même compte peut être rattaché à plusieurs temples avec des rôles différents, et chaque temple a son propre forfait et son propre abonnement.",
		},
		payments: {
			q: "Est-ce qu'ORI encaisse les paiements ?",
			a: "Oui, via Mercado Pago. L'intégration est une option facultative du forfait : vous connectez le compte du temple et encaissez cotisations et contributions par PIX ou par carte, avec rapprochement automatique et prélèvement récurrent. Les frais de chaque transaction sont prélevés par Mercado Pago lui-même, et l'argent est versé directement sur le compte du temple.",
		},
	},
	cta: {
		eyebrow: "Commencez aujourd'hui",
		title: "Prêt à organiser votre temple ?",
		text: "Essayez ORI pendant 30 jours, sans engagement et sans carte. Il ne faut que quelques minutes pour commencer.",
		primary: "Créer mon temple",
		secondary: "Nous contacter",
	},
	footer: {
		tagline: "Construit par un enfant de l'Axé pour un autre enfant de l'Axé.",
		invite: "J'ai une invitation",
		manual: "Manuel",
		terms: "Conditions d'utilisation",
		privacy: "Politique de confidentialité",
		cause: "Nous soutenons la cause autiste",
		causeAlt: "Ruban de l'autisme",
	},
};
